import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/LoginPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import ContactPage from './pages/ContactPage'
import DashboardPage from './pages/DashboardPage'
import ProfilePage from './pages/ProfilePage'
import CommunityPage from './pages/CommunityPage'
import SubscriptionRedirectPage from './pages/SubscriptionRedirectPage'
import { PublicVerdictPage } from './pages/PublicVerdictPage'
// import { LoadingSpinner } from '@treu/ui-components'
const LoadingSpinner = () => <div>Loading...</div>

function App() {
  const { authState } = useAuth()

  switch (authState.status) {
    case 'loading':
      return <LoadingSpinner />

    case 'unauthenticated':
      return (
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/subscription-redirect" element={<SubscriptionRedirectPage />} />
            {/* Public shared verdict — must resolve logged-out */}
            <Route path="/v/:shortId" element={<PublicVerdictPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ErrorBoundary>
      )

    case 'authenticated':
      return (
        <ErrorBoundary>
          <Routes>
            {/* Legal pages have their own header/footer, rendered outside the app Layout */}
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* Public shared verdict — same page logged-in, outside the app Layout */}
            <Route path="/v/:shortId" element={<PublicVerdictPage />} />
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/community" element={<CommunityPage />} />
                    <Route path="/subscription-redirect" element={<SubscriptionRedirectPage />} />
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </ErrorBoundary>
      )
  }
}

export default App